// extracted by mini-css-extract-plugin
module.exports = {"loaderPosition":"_1_yuwKZq","adminButtonHolder":"_3qgzecr0","buttonMargin":"_1PBrCafY","adminFormPage":"_35pBgDhH","inputStyle":"_-02gtFQE"};